export default __webpack_public_path__ + "static/media/leggings_of_ferine_anger.fda191c1.jpg";